export const InformationSliceConstants = {
  GetInformation: 'getInformation',
  GetNews: 'getNews',
  GetLatestInformation: 'getLatestInformation',
  GetHomeInformation: 'getHomeInformation',
};
